/* eslint-disable no-undef */
let environment = process ? process.env.ENV : 'unknown';
export const setEnvironment = env => {
  if (env) environment = env;
};
export const getEnvironment = () => environment;
export const isServer = () => SERVER_SIDE;
export const getActualYear = () => ACTUAL_YEAR;
export const getSystem = () => System;
